































import Vue from 'vue';
import Component from 'vue-class-component';
import { VueTelInput } from 'vue-tel-input';

@Component({
  components: { VueTelInput }
})
export default class MobileActivation extends Vue {
  phoneNumber: string | null = null;

  mounted() {
    this.phoneNumber = this.$route.params.phoneNumber;
  }
  textMeDownloadLink(): void {
    // console.log('text me the download link');
    this.$router.push('/');
  }

  goToPlayStore(): void {
    window.location.assign(
      'https://play.google.com/store/apps/details?id=com.parsyl'
    );
  }
}
